module.exports = __webpack_public_path__ + "img/logo_14.9ce8df89.png";